import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Certificate } from '../../../../../core/models/certificate';
import { CertificatesService } from '../../../../../core/services/api/certificates.service';
import { CommonModule } from '@angular/common';
import { from, Observable, tap } from 'rxjs';
import { CertificateHistory } from '../../../../../core/models/certificate-history';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { LingFileEntity } from '../../../../../core/models/ling-file-entity';
import { environment } from '../../../../../../environments/environment';
import { CertificateTransferOperation } from '../../../../../core/enums';
import { SnackBarService } from '../../../../../core/services/snack-bar.service';

const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  position: 'above',
};

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatTooltipModule,
  ],
  selector: 'ling-cert-history-dialog',
  templateUrl: './cert-history-dialog.component.html',
  styleUrls: ['./cert-history-dialog.component.scss'],
  providers: [
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults },
  ],
})
export class CertHistoryDialogComponent {
  watchCertificateHistory?: Observable<Required<CertificateHistory>>;
  isLoading = true;
  dateFormat = 'dd.MM.YY, HH:mm';
  CertificateTransferOperation = CertificateTransferOperation;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogParams: {
      certificate: Certificate;
    },
    private certificatesService: CertificatesService,
    private message: SnackBarService,
    private translateService: TranslateService
  ) {
    this.watchCertificateHistory = certificatesService
      .watchCertificateHistory(this.dialogParams.certificate._id!)
      .pipe(
        tap({
          next: () => (this.isLoading = false),
          error: () => (this.isLoading = false),
        })
      );
  }

  getImageURL(lingFileEntity?: LingFileEntity) {
    if (lingFileEntity?.file?.filename) {
      return environment.url + '/files/' + lingFileEntity.file?.filename;
    }
    return null;
  }

  copyText(text: string): void {
    from(navigator.clipboard.writeText(text)).subscribe(() => {
      this.message.success(
        this.translateService.instant('snackbar.success.keyCopied')
      );
    });
  }
}
